<mat-card class="q2-contact-info-card shadow-none border-solid border-gray-100 my-6">
	<mat-card-title class="mb-4">Contact Info</mat-card-title>
	<mat-card-content>
		<p class="q2-detail-item" fxLayout fxLayoutAlign="start center" *ngFor="let item of data | keyvalue">
			<strong class="mr-4">{{ item.key | titlecase }}:</strong>
			<span>{{ item.value }}</span>
		</p>
	</mat-card-content>
</mat-card>
